import React, { useEffect, useState } from 'react';
import styles from '../styles/PaymentConstructor.module.css';
import PaymentInfo from './PaymentInfo';
import PaymentWalletInfo from './PaymentWalletInfo';

const PaymentConstructor = () => {
  const [tariffs, setTariffs] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedTariffId, setSelectedTariffId] = useState(null);
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);
  const [amount, setAmount] = useState(0);
  const [balance, setUserBalance] = useState(0);
 

  useEffect(() => {
    fetch('/api/tarif/tariffs')
      .then((res) => res.json())
      .then(setTariffs)
      .catch(console.error);

    fetch('/api/tarif/services')
      .then((res) => res.json())
      .then(setServices)
      .catch(console.error);
  }, []);

  const selectedTariff = tariffs.find((t) => t.id === selectedTariffId);
  const selectedServiceCost = selectedServiceIds.reduce((acc, id) => {
    const service = services.find((s) => s.id === id);
    return acc + (service ? parseFloat(service.month_price) : 0);
  }, 0);
  const minValue = (selectedTariff?.month_price ? parseFloat(selectedTariff.month_price) : 0) + selectedServiceCost;

  useEffect(() => {
    const tariff = tariffs.find((t) => t.id === selectedTariffId);
    const serviceCost = selectedServiceIds.reduce((acc, id) => {
      const service = services.find((s) => s.id === id);
      return acc + (service ? parseFloat(service.month_price) : 0);
    }, 0);

    const calculatedMin = (tariff?.month_price ? parseFloat(tariff.month_price) : 0) + serviceCost;

    setAmount((prev) => {
      if (prev < calculatedMin) return calculatedMin;
      if (prev !== minValue && prev > calculatedMin) return calculatedMin;
      return prev;
    });
  }, [selectedTariffId, selectedServiceIds, tariffs, services]);

  const payload = {
    price: amount.toFixed(2), // сумма как строка вида "1290.00"
    description: `Оплата тарифа ${selectedTariff?.name || 'Без тарифа'} + доп. сервисы`,
    tarif: selectedTariffId, // id выбранного тарифа или null
    services: selectedServiceIds, // список ID выбранных сервисов
  };

  const handlePay = async () => {
    try {
      const payload = {
        price: amount.toFixed(2),
        description: `Право использования ПО для ЭВМ тариф ${selectedTariff?.name || 'Баланс'} + доп. сервисы  (на 30 дней)`,
        tarif: selectedTariffId,
        services: selectedServiceIds,
      };
  
      const res = await fetch('/yookassa/yookassa', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });
  
      const result = await res.json();

      if (res.ok && result.token) {
        window.location.href = `/checkout?token=${result.token}`;
      } else {
        console.error(result.error || 'Ошибка создания платежа');
      }
    } catch (err) {
      console.error('Ошибка запроса:', err);
    }
  };
  


  return (
    <div className={styles.container}>
      <PaymentWalletInfo
          onBalanceChange={(balance) => setUserBalance(balance)}
        />

      <PaymentInfo/>
      <div className={styles.section_tarifs}>
        <label>Выберите тариф:</label>
        <select
          className={styles.select}
          value={selectedTariffId === null ? '' : selectedTariffId}
          onChange={(e) => {
            const value = e.target.value;
            setSelectedTariffId(value === '' ? null : parseInt(value));
          }}
        >
          <option value="">Пополнение баланса (или только доп. сервисы)</option>
          {tariffs.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name} ({t.month_price}₽ / 30 дней)
            </option>
          ))}
        </select>
      </div>

      <div className={styles.section_line}>
        <label className={styles.sum}>Сумма: {amount}₽</label>
        <input
          type="range"
          min={minValue}
          max={30000}
          step={100}
          value={amount}
          onChange={(e) => setAmount(parseInt(e.target.value))}
          className={styles.slider}
        />
        <div className={styles.amountInfo}>Минимум: {minValue}₽</div>
      </div>
      <div className={styles.section_services}>
        <label>Дополнительные сервисы:</label>
        {services.map((s) => (
          <div key={s.id} className={styles.checkboxLine}>
            <input
              type="checkbox"
              id={`s-${s.id}`}
              checked={selectedServiceIds.includes(s.id)}
              onChange={() => {
                setSelectedServiceIds((prev) =>
                  prev.includes(s.id) ? prev.filter((id) => id !== s.id) : [...prev, s.id]
                );
              }}
            />
            <label htmlFor={`s-${s.id}`}>
              {s.name} ({s.month_price}₽ / 30 дней)
            </label>
          </div>
        ))}
      </div>

      <div className={styles.buttonWrapper}>
            <button
                    className={styles.payButton}
                    disabled={amount < minValue}
                    onClick={handlePay}
                    >
                    Перейти к оплате
            </button>          
      </div>

      <div className={styles.tariffCards}>
        {/* <div
          className={`${styles.tariffCard} ${selectedTariffId === null ? styles.selected : ''}`}
          onClick={() => setSelectedTariffId(null)}
        >
          Только дополнительные сервисы
        </div> */}
        {tariffs.map((t) => (
          <div
            key={t.id}
            className={`${styles.tariffCard} ${selectedTariffId === t.id ? styles.selected : ''}`}
            onClick={() => setSelectedTariffId(t.id)}
          >
            <h3>{t.name}</h3>
            <p>{t.month_price}₽ / 30 дней</p>
            <div dangerouslySetInnerHTML={{ __html: t.description }} />
          </div>
        ))}
      </div>

      
      

    </div>
  );
};

export default PaymentConstructor;
